import { withNamespaces } from 'react-i18next';
import { Alert } from 'reactstrap';

const TEST_STATUS_VARIANTS = {
    success: {
        color: 'success',
        icon: 'ri-check-line',
        titleKey: 'Connection test successful',
        fallbackKey: 'Connection successful. Emails can be sent.',
    },
    info: {
        color: 'info',
        icon: 'ri-information-line',
        titleKey: 'Connection test incomplete',
        fallbackKey: 'SMTP OK. Entra app is saved — Connect Microsoft next.',
    },
    error: {
        color: 'danger',
        icon: 'ri-error-warning-line',
        titleKey: 'Connection test failed',
        fallbackKey: 'Connection failed. Save is still allowed.',
    },
};

const TestStatusAlert = ({
    t,
    testStatus,
    testMessage,
}) => {
    const variant = TEST_STATUS_VARIANTS[testStatus];

    if (!variant) {
        return null;
    }

    return (
        <Alert color={variant.color} className="mb-4">
            <div className="fw-semibold">
                <i className={`${variant.icon} align-middle me-1 font-size-18`} />
                {t(variant.titleKey)}
            </div>
            <div className="font-size-13">
                {testMessage || t(variant.fallbackKey)}
            </div>
        </Alert>
    );
};

export default withNamespaces()(TestStatusAlert);
